import TransferDetails from './TransferDetails';

export default TransferDetails;
